export default {
  getRomaneios(state) {
    return state.romaneios;
  },
  getRomaneioSelecionado(state) {
    // eslint-disable-next-line max-len
    return state.romaneioSelecionado && state.romaneioSelecionado.idRegistro ? state.romaneioSelecionado : {};
  },
  getColunasData(state) {
    return state.colunasData;
  },
  getExpandColumns(state) {
    return state.expandColumns;
  },
  getColumns(state) {
    return state.columns;
  },
};
